import { erpAxios } from '.';

const getLoan = async (id) => {
  const { data } = await erpAxios.get(`/loan/getLoanByZahtjevId/${id}`);
  return data;
};

export default getLoan;
